import { capFirstWord as capFirstWordMethod, combineStringWithDelimiter as combineStringWithDelimiterMethod, displayMaxDp as displayMaxDpMethod, parseCamelCase as parseCamelCaseMethod, numberWithCommas as numberWithCommasMethod, stringParser as stringParserMethod } from 'src/plugins/string/string';
/**
 * Wrapper for string methods in 'src/plugins/string/string'
 * @returns wrapped string methods for use in setup
 */
const AppStringMethods = () => {
    function displayMaxDp(x, max_dp = 2, min_dp = 0) {
        return displayMaxDpMethod(x, max_dp, min_dp);
    }
    function numberWithCommas(x, dp = 2) {
        return numberWithCommasMethod(x, dp);
    }
    function parseCamelCase(string, splitter = ' ') {
        return parseCamelCaseMethod(string, splitter);
    }
    function capFirstWord(string) {
        return capFirstWordMethod(string);
    }
    function stringParser(id = null, string = null) {
        return stringParserMethod(id, string);
    }
    function combineStringWithDelimiter(string, delimiter = '-') {
        return combineStringWithDelimiterMethod(string, delimiter);
    }
    return { numberWithCommas, parseCamelCase, capFirstWord, stringParser, combineStringWithDelimiter, displayMaxDp };
};
export { AppStringMethods };
